import { useEffect, useState } from "react";
import {
  EMPTY_CALENDAR_OFFS,
  parseCalendarOffsFromQueryData
} from "hooks/parse-calendar-offs";
import { getCalendarOffs } from "../services";

export function useMaterialPlanningCalendarOffs(projectToken?: string) {
  const [calendarOffs, setCalendarOffs] = useState(EMPTY_CALENDAR_OFFS);

  useEffect(() => {
    if (!projectToken) {
      setCalendarOffs(EMPTY_CALENDAR_OFFS);
      return undefined;
    }

    let cancelled = false;

    getCalendarOffs(projectToken).then((response) => {
      if (cancelled) return;

      if (response.success) {
        setCalendarOffs(parseCalendarOffsFromQueryData(response.data));
      } else {
        setCalendarOffs(EMPTY_CALENDAR_OFFS);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [projectToken]);

  return { calendarOffs };
}
